'use client'

import { useState, useEffect } from "react";
import styles from "./Menu.module.css";
import { useSubmenu } from "../../hooks/useSubmenu";
import classNames from "classnames";
import Logo from "../Logo/Logo";
import Button from "../Button/Button";
import { usePathname, useRouter } from "next/navigation";
import Link from "next/link";

function Menu() {
  const { submenuOpen, toggleSubmenu, submenuRef } = useSubmenu();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useRouter();
  const pathname = usePathname();
  

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [menuOpen]);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const extraClass = pathname.startsWith("/EuQuero/SolicitarBVA") ? styles.produtoAssinar : "";
  
  const isOnEuQuero = pathname === '/EuQuero/SolicitarBVA';

  const navClass = isOnEuQuero ? styles.btnAssinar : '';

  // Fecha com Esc
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setMenuOpen(false);
      }
    };

    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  return (
    <header className={styles.bgHeader} id="menu">
      <div className="uiContainer">
        <div className={styles.dflex}>
          <a href="/" aria-label="Acessar Página Home">
            <Logo/>
          </a>

          <nav className={`${styles.navMenu} ${extraClass} ${menuOpen ? styles.menuOpen : ""}`}>
            <ul>
              <li>
                <Link
                  href="/"
                  className={classNames(styles.LinkItem, {
                    [styles.active]: pathname === "/",
                  })}
                  aria-label="Acessar Página Home"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  href="/QuemSomos/"
                  className={classNames(styles.LinkItem, {
                    [styles.active]: pathname === "/QuemSomos/",
                  })}
                  aria-label="Acessar Página Quem Somos"
                >
                  Quem Somos
                </Link>
              </li>
              <li className={styles.hasSubmenu} ref={submenuRef}>
                <button
                  type="button"
                  className={classNames(styles.LinkItem)}
                  onClick={toggleSubmenu}
                  aria-haspopup="true"
                  aria-expanded={submenuOpen ? "true" : "false"}
                  aria-controls="submenu-produtos"
                >
                  Produtos
                  <svg className={styles.arrow} width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.33374 1L4.83374 5L8.33374 1" stroke="#0C233A" strokeWidth="2"/>
                  </svg>
                </button>
                {/* <Link
                  href="/Produtos/"
                  className={classNames(styles.LinkItem, {
                    [styles.active]: pathname === "/Produtos/",
                  })}
                  onClick={toggleSubmenu}
                  aria-label="Acessar Página Produtos"
                  aria-expanded={submenuOpen ? "true" : "false"}
                >
                  Produtos<svg className={styles.arrow} width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.33374 1L4.83374 5L8.33374 1" stroke="#0C233A" strokeWidth="2"/>
                  </svg>
                </Link> */}

                {submenuOpen && (
                  <ul
                    id="submenu-produtos"
                    className={styles.submenu}
                    role="menu"
                  >
                    <li role="none">
                      <Link role="menuitem" href="/Produtos/EnsinoSuperior/" aria-label="Para Instituições de Ensino - Ensino Superior. Enriqueça a bibliografia da sua instituição.">
                      <span className={classNames(styles.CatProduct, styles.blue)}>Para Instituições de</span>
                      <div className={styles.titleProduct}> Ensino Superior <svg aria-hidden="true" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.8125 0.71875C6.9375 0.5625 7.1875 0.5625 7.34375 0.71875L13.875 7.25C14.0312 7.40625 14.0312 7.625 13.875 7.78125L7.34375 14.3125C7.1875 14.4688 6.9375 14.4688 6.8125 14.3125L6.1875 13.7188C6.03125 13.5625 6.03125 13.3125 6.1875 13.1875L11.0312 8.3125H0.375C0.15625 8.3125 0 8.15625 0 7.9375V7.0625C0 6.875 0.15625 6.6875 0.375 6.6875H11.0312L6.1875 1.84375C6.03125 1.71875 6.03125 1.46875 6.1875 1.3125L6.8125 0.71875Z" fill="#0C233A" />
                        </svg>
                      </div>
                      </Link>
                    </li>
                    <li role="none">
                      <Link role="menuitem" href="/Produtos/EnsinoTecnico/" aria-label="Para Instituições de Ensino - Ensino Técnico. Fortaleça a formação com acervo digital.">
                      <span className={classNames(styles.CatProduct, styles.blueLight)}>Para Instituições de</span>
                      <div className={styles.titleProduct}> Ensino Técnico <svg aria-hidden="true" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.8125 0.71875C6.9375 0.5625 7.1875 0.5625 7.34375 0.71875L13.875 7.25C14.0312 7.40625 14.0312 7.625 13.875 7.78125L7.34375 14.3125C7.1875 14.4688 6.9375 14.4688 6.8125 14.3125L6.1875 13.7188C6.03125 13.5625 6.03125 13.3125 6.1875 13.1875L11.0312 8.3125H0.375C0.15625 8.3125 0 8.15625 0 7.9375V7.0625C0 6.875 0.15625 6.6875 0.375 6.6875H11.0312L6.1875 1.84375C6.03125 1.71875 6.03125 1.46875 6.1875 1.3125L6.8125 0.71875Z" fill="#0C233A" />
                        </svg>
                      </div>
                      </Link>
                    </li>
                    <li role="none">
                      <Link role="menuitem" href="/Produtos/Corporativo/" aria-label="Para Empresas - Corporativo. Desenvolva habilidades e promova inovação.">
                      <span className={classNames(styles.CatProduct, styles.yellow)}>Para Empresas</span>
                      <div className={styles.titleProduct}> Corporativo <svg aria-hidden="true" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.8125 0.71875C6.9375 0.5625 7.1875 0.5625 7.34375 0.71875L13.875 7.25C14.0312 7.40625 14.0312 7.625 13.875 7.78125L7.34375 14.3125C7.1875 14.4688 6.9375 14.4688 6.8125 14.3125L6.1875 13.7188C6.03125 13.5625 6.03125 13.3125 6.1875 13.1875L11.0312 8.3125H0.375C0.15625 8.3125 0 8.15625 0 7.9375V7.0625C0 6.875 0.15625 6.6875 0.375 6.6875H11.0312L6.1875 1.84375C6.03125 1.71875 6.03125 1.46875 6.1875 1.3125L6.8125 0.71875Z" fill="#0C233A" />
                        </svg>
                      </div>
                      </Link>
                    </li>
                    {/* <li role="none">
                      <Link role="menuitem" href="/Produtos/Assinante/" aria-label="Produto Assinante">
                        <span className={classNames(styles.CatProduct, styles.purple)}>Para Você</span>
                        <div className={styles.titleProduct}>
                            Assinante 

                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.8125 0.71875C6.9375 0.5625 7.1875 0.5625 7.34375 0.71875L13.875 7.25C14.0312 7.40625 14.0312 7.625 13.875 7.78125L7.34375 14.3125C7.1875 14.4688 6.9375 14.4688 6.8125 14.3125L6.1875 13.7188C6.03125 13.5625 6.03125 13.3125 6.1875 13.1875L11.0312 8.3125H0.375C0.15625 8.3125 0 8.15625 0 7.9375V7.0625C0 6.875 0.15625 6.6875 0.375 6.6875H11.0312L6.1875 1.84375C6.03125 1.71875 6.03125 1.46875 6.1875 1.3125L6.8125 0.71875Z" fill="#0C233A"/>
                            </svg>
                        </div>

                      </Link>
                    </li> */}
                  </ul>
                )}
              </li>
              <li>
                <Link
                  href="/Recursos/"
                  className={classNames(styles.LinkItem, {
                    [styles.active]: pathname === "/Recursos/",
                  })}
                  aria-label="Acessar Página Recursos"
                >
                  Recursos
                </Link>
              </li>
              <li>
                <Link
                  href="/NossoAcervo/"
                  className={classNames(styles.LinkItem, {
                    [styles.active]: pathname === "/NossoAcervo/",
                  })}
                  aria-label="Conheça nosso Acervo"
                >
                  Nosso Acervo
                </Link>
              </li>
              <li>
                <Link
                  href="/Blog/"
                  className={classNames(styles.LinkItem, {
                    [styles.active]: pathname === "/Blog/",
                  })}
                  aria-label="Acessar Página Blog"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  href="/Contato/"
                  className={classNames(styles.LinkItem, {
                    [styles.active]: pathname === "/Contato/",
                  })}
                  aria-label="Acessar Página Contato"
                >
                  Contato
                </Link>
              </li>
              <li className={styles.LinkItemMobile}>
                <Link
                  href="/EuQuero/"
                  className={classNames(styles.LinkItem)}
                  aria-label="Eu Quero - Ir para página Experimente"
                >
                  Eu Quero
                </Link>
              </li>
              <li className={styles.LinkItemMobile}>
                <Link
                  href="https://plataforma.bvirtual.com.br/"
                  className={styles.LinkItem}
                  target="_blank"
				  aria-label="Entrar na plataforma (abre em nova aba)"
      rel="noopener noreferrer" 
                >
                  <svg aria-hidden="true" width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.55859 9.0625C10.582 9.0625 12.25 10.7305 12.25 12.7539V13.4375C12.25 14.1758 11.6484 14.75 10.9375 14.75H1.3125C0.574219 14.75 0 14.1758 0 13.4375V12.7539C0 10.7305 1.64062 9.0625 3.66406 9.0625C4.45703 9.0625 4.8125 9.5 6.125 9.5C7.41016 9.5 7.76562 9.0625 8.55859 9.0625ZM10.9375 13.4375V12.7539C10.9375 11.4414 9.87109 10.375 8.55859 10.375C8.14844 10.375 7.51953 10.8125 6.125 10.8125C4.70312 10.8125 4.07422 10.375 3.66406 10.375C2.35156 10.375 1.3125 11.4414 1.3125 12.7539V13.4375H10.9375ZM6.125 8.625C3.9375 8.625 2.1875 6.875 2.1875 4.6875C2.1875 2.52734 3.9375 0.75 6.125 0.75C8.28516 0.75 10.0625 2.52734 10.0625 4.6875C10.0625 6.875 8.28516 8.625 6.125 8.625ZM6.125 2.0625C4.67578 2.0625 3.5 3.26562 3.5 4.6875C3.5 6.13672 4.67578 7.3125 6.125 7.3125C7.54688 7.3125 8.75 6.13672 8.75 4.6875C8.75 3.26562 7.54688 2.0625 6.125 2.0625Z" fill="#0C233A"></path></svg> <span>Entrar</span>
                </Link>
              </li>
            </ul>
          </nav>

          <div className={styles.hamburger} onClick={toggleMenu}>
            <span className={classNames(styles.bar, { [styles.open]: menuOpen })}></span>
            <span className={classNames(styles.bar, { [styles.open]: menuOpen })}></span>
            <span className={classNames(styles.bar, { [styles.open]: menuOpen })}></span>
            <span className={classNames(styles.bar, { [styles.open]: menuOpen })}></span>
          </div>

          <nav className={styles.containerBtn}>
            <ul>
              <li>
                <Button text="Eu Quero" arialabel="Eu quero experimentar a Biblioteca Virtual" className={classNames(styles.btn, styles.blueLight, navClass)} onClick={() => navigate.push("/EuQuero/")}/>
              </li>
              <li>
                <Button text="Entrar" arialabel="Entrar na Biblioteca Virtual" className={classNames(styles.btn, styles.blue, navClass)} onClick={() => window.open("https://plataforma.bvirtual.com.br", "_blank")}>
                    <svg aria-hidden="true" width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.55859 9.0625C10.582 9.0625 12.25 10.7305 12.25 12.7539V13.4375C12.25 14.1758 11.6484 14.75 10.9375 14.75H1.3125C0.574219 14.75 0 14.1758 0 13.4375V12.7539C0 10.7305 1.64062 9.0625 3.66406 9.0625C4.45703 9.0625 4.8125 9.5 6.125 9.5C7.41016 9.5 7.76562 9.0625 8.55859 9.0625ZM10.9375 13.4375V12.7539C10.9375 11.4414 9.87109 10.375 8.55859 10.375C8.14844 10.375 7.51953 10.8125 6.125 10.8125C4.70312 10.8125 4.07422 10.375 3.66406 10.375C2.35156 10.375 1.3125 11.4414 1.3125 12.7539V13.4375H10.9375ZM6.125 8.625C3.9375 8.625 2.1875 6.875 2.1875 4.6875C2.1875 2.52734 3.9375 0.75 6.125 0.75C8.28516 0.75 10.0625 2.52734 10.0625 4.6875C10.0625 6.875 8.28516 8.625 6.125 8.625ZM6.125 2.0625C4.67578 2.0625 3.5 3.26562 3.5 4.6875C3.5 6.13672 4.67578 7.3125 6.125 7.3125C7.54688 7.3125 8.75 6.13672 8.75 4.6875C8.75 3.26562 7.54688 2.0625 6.125 2.0625Z" fill="white"/>
                    </svg>
                </Button>
                
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Menu;